<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <p-form showSearch>
      <template v-slot:content>
        <v-container fluid>
          <v-row justify="center">
            <v-col cols="12" >
              <h4>Apuração</h4>
            </v-col>

            <v-col cols="10" >
              <v-chip v-for="(item, i) in meuJogo" :key="'linha'+i">{{zeroEsquerda(item,2)}}</v-chip>
            </v-col>

            <v-col cols="2">
              <v-btn variant="text" icon size="small">
                <v-icon color="green" @click="editar(apuracao)">
                  {{validarCampo(apuracao.num1) ? 'mdi-pencil' : 'mdi-plus'}}
                  <!--mdi-plus-->

                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
          <!--<table-iterator :itens="listaApuracaos.data" @item=itens @ordem="ordem" @paginas="pegarNovaLista"-->
                          <!--:setPagina="setPage" :totalPaginas="listaApuracaos.last_page" @por_paginas="setPorPaginas"-->
                          <!--:PorPage="parseInt(listaApuracaos.per_page)" :cabecalho="cabecalho" :show-add-button="true"-->
                          <!--header @novo="novo">-->
            <!--<template v-slot:[n.slot_name]="props" v-for="(n, index) in cabecalho">-->
              <!--<div :key="'outros'+index">{{props.item[n.slot_name]}}</div>-->
            <!--</template>-->
            <!--<template v-slot:acao="props">-->
              <!--<div style="width: 100%; text-align: right;">-->
                <!--<v-btn variant="text" icon size="small">-->
                  <!--<v-icon color="green" @click="editar(props.item)">mdi-pencil</v-icon>-->
                <!--</v-btn>-->
                <!--<v-btn variant="text" icon size="small">-->
                  <!--<v-icon color="red" @click="remover(props.item)">mdi-delete</v-icon>-->
                <!--</v-btn>-->
              <!--</div>-->
            <!--</template>-->
          <!--</table-iterator>-->

        <!--</v-container>-->
        <pro-modal-cadastro :modal="dialogCadastro" width="50%" titulo="Cadastrar Apuracao">
          <v-container>
            <v-row justify="center">
              <!--<v-col cols="12" >-->
                <!--<h4>Apuração</h4>-->
              <!--</v-col>-->
              <!--<v-col cols="12" >-->
                <!--<v-chip v-for="(item, i) in meuJogo" :key="'linha'+i">{{zeroEsquerda(item,2)}}</v-chip>-->
              <!--</v-col>-->

              <v-col cols="12" sm="12" md="12" class="jogo">
                <table>
                  <tr v-for="(item, i) in apuracaoArray" :key="'linha'+i">
                    <td v-for="(col, index) in item.linha" :key="'col' +i+ index" @click="selecionar(col)"
                        :class="getClasse(col)">{{zeroEsquerda(col,2)}}
                    </td>
                  </tr>
                </table>
                <div style="text-align: left">
                  <br>
                  <!--<p>Qtd. Núm. selecionados: {{meuJogo.length}}</p>-->
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="commit()" :loading="loading">
              Confirmar
            </v-btn>
            <v-btn text @click="cancelar()">
              Cancelar
            </v-btn>
          </v-card-actions>
        </pro-modal-cadastro>
      </template>
    </p-form>
  </div>
</template>

<script>
/* eslint-disable */
  import {mapActions, mapGetters} from 'vuex'
  import paginacao from '../../helpers/paginacao'
  import miscMixin from '../../helpers/misc'
  import {acaoApi} from '../../helpers/enums'
  import {EventBus} from '../../helpers/event-bus'

  export default {
    mixins: [miscMixin, paginacao],
    name: 'Apuracaos',
    data: () => ({
      // apuracao: [],
      meuJogo: [],
      apuracaoArray: [
        {linha: [1, 2, 3, 4, 5]},
        {linha: [6, 7, 8, 9, 10]},
        {linha: [11, 12, 13, 14, 15]},
        {linha: [16, 17, 18, 19, 20]},
        {linha: [21, 22, 23, 24, 25]},
      ],
      editando: false,
      removendo: false,
      dialogCadastro: false,
      show1: false,
      show2: false,
      loading: false,
      cabecalho: [
        {
          text: 'Nome',
          value: 'nome',
          align: 'left',
          slot: 'item.nome',
          slot_name: 'nome'
        },
        {
          text: 'Opções',
          value: 'actions',
          align: 'right',
          notBtn: true,
          sortable: false
        }
      ],
    }),
    methods: {
      ...mapActions('apuracao', ['setAllApuracaos', 'setFiltro', 'searchItem', 'processarApuracao','setApuracao']),
      getClasse(num) {
        var achou = this.meuJogo.find(list => list === num)
        return this.validarCampo(achou) ? 'is_selected' : 'is_not_selected'
      },
      selecionar(num) {
        if (this.meuJogo.length <= 0) {
          this.meuJogo.push(num)
        } else {
          // if (this.meuJogo.length<15) {
          var achou = this.meuJogo.find(list => list === num)
          if (!this.validarCampo(achou)) {
            if (this.meuJogo.length < 15) {
              this.meuJogo.push(num)
            } else {
              alert('Voce atigiu o limite de numeros para selecionar')
            }
          } else {
            let pos = this.meuJogo.indexOf(achou)
            this.meuJogo.splice(pos, 1)
          }
        }
      },
      cancelar() {
        this.dialogCadastro = !this.dialogCadastro
        this.carregarLista()
      },
      commit() {
        var array = this.ordenarLista(this.meuJogo)
        for (var i = 0; i < array.length; i++) {
          this.apuracao['num' + (i + 1)] = array[i]
        }
        this.processarApuracao({
          apuracao: this.apuracao,
          acao: acaoApi.GRAVAR,
          onSucesso: () => {
            this.loading = false
            // this.apuracao = new Apuracao()
            this.meuJogo = []
            this.cancelar()
          },
          onErro: () => {
            this.loading = false
          }
        })
      },
      editar(item) {
        this.meuJogo = []
        // this.apuracao = item
        this.setApuracao(item)
        this.editando = true
        this.cancelar()
      },
      remover(item) {
        this.removendo = !this.removendo
        let _this = this
        this.$dialog.confirm('Deseja excluir esse Registro?')
          .then(function(dialog) {
            _this.processarApuracao({
              apuracao: item,
              acao: acaoApi.REMOVER,
              onSucesso: () => {
                _this.closeDialog(dialog)
                _this.carregarLista()
              },
              onErro: () => {
              }
            })
          })
      },
      novo() {
        this.editando = false
        this.file = null
        this.dialogCadastro = !this.dialogCadastro
        // this.apuracao = new Apuracao()
        this.imagens = []
      },
      carregarLista() {
        this.setAllApuracaos({
          onSucesso: () => {
            EventBus.$emit('SHOW_LISTA', true)
            this.meuJogo = []
            if (this.validarCampo(this.apuracao.num1)) {
              for (var i = 0; i < 15; i++) {
                this.meuJogo.push(this.apuracao['num' + (i + 1)])
              }
            }

          },
          onErro: () => {
            EventBus.$emit('SHOW_LISTA', false)
          }
        })
      }
    },
    computed: {
      ...mapGetters('apuracao', {
        apuracao: 'pegaApuracao',
        listaApuracaos: 'listaApuracaos',
        filtro: 'pegaFiltro'
      })
    },
    created() {
      this.setFiltro(this.itemsPerPage)
      this.carregarLista()
    },
    mounted() {
      for (var i = 0; i < 15; i++) {
        this.meuJogo.push(this.zeroEsquerda(0,2))
      }
    },
  }
</script>
<style scoped lang="scss">
  .jogo {
    tr, td {
      padding: 10px;
      border: 1px solid #ccc;
      text-align: center;
      font-size: 20px;

    }

    table {
      border: 1px solid #ccc;
      padding: 5px;
      text-align: center;
    }
  }

</style>
